import { createToaster, Toaster as ChakraToaster } from '@chakra-ui/react';

export const toaster = createToaster({
  placement: 'top-end',
  duration: 3000,
});

export const Toaster = ChakraToaster;
